import React, { useState, useEffect } from 'react';
import * as serviceWorkerRegistration from '../serviceWorkerRegistration';

/**
 * Componente que notifica o usuário quando uma nova versão do aplicativo está disponível
 * e oferece a opção de atualizar
 */
function PwaUpdateNotifier() {
  const [showReload, setShowReload] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  const onSWUpdate = (registration) => {
    setShowReload(true);
    setWaitingWorker(registration.waiting);
  };

  useEffect(() => {
    // Registra o service worker com o callback para atualização
    serviceWorkerRegistration.register({
      onUpdate: onSWUpdate,
    });
  }, []);

  const reloadPage = () => {
    waitingWorker?.postMessage({ type: 'SKIP_WAITING' });
    setShowReload(false);
    window.location.reload();
  };

  if (!showReload) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-blue-600 text-white p-4 flex justify-between items-center z-50">
      <p className="text-sm">Uma nova versão está disponível!</p>
      <div className="flex gap-2">
        <button 
          onClick={() => setShowReload(false)}
          className="px-3 py-1 bg-blue-700 rounded-md text-sm hover:bg-blue-800 transition-colors"
        >
          Depois
        </button>
        <button 
          onClick={reloadPage}
          className="px-3 py-1 bg-white text-blue-600 rounded-md text-sm font-semibold hover:bg-gray-100 transition-colors"
        >
          Atualizar
        </button>
      </div>
    </div>
  );
}

export default PwaUpdateNotifier; 